/**
 *
 * @param {string} str
 * @returns string
 */
function normalizeAccents(str) {
    try {
        return str
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replaceAll('.', '')
            .toLowerCase()
    } catch (e) {
        console._log('normalize failed for', str) // eslint-disable-line no-console, no-underscore-dangle
        return str
    }
}

module.exports = {
    normalizeAccents,
}
